<div class=" border rounded calculator shadow p-3 bg-light text-start">
    <h5 class="mb-3 text-primary">Calculadora</h5>
  
    <!-- Pantalla de la Calculadora -->
    <div class="output border rounded mb-3 p-2 bg-white">
      <div class="current-input text-muted text-end">{{ currentInput }}</div>
      <div class="result text-primary fs-3 fw-bold text-end">{{ result }}</div>
    </div>
  
    <!-- Información para el Usuario -->
    <p class="text-muted small">Usa el teclado para operar (C = Limpiar, Enter = Resultado)</p>
  </div>